import { render, staticRenderFns } from "./PlanOfferItem.vue?vue&type=template&id=6a37048e&scoped=true&"
import script from "./PlanOfferItem.vue?vue&type=script&lang=js&"
export * from "./PlanOfferItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanOfferItem.vue?vue&type=style&index=0&id=6a37048e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37048e",
  null
  
)

export default component.exports